import { Fragment } from 'react'
import { FormattedMessage } from 'react-intl'
import AdventureExploration from './AdventureExploration'

export default function Exploration({ coords }) {
  return (
    <Fragment>
      <AdventureExploration
        sectionTitle={
          <FormattedMessage
            id='dive_trips_nearby'
            defaultMessage='Dive trips nearby'
          />
        }
        coords={coords}
        link={window.searchDives}
        type='dive-trips'
      />
      <AdventureExploration
        sectionTitle={
          <FormattedMessage
            id='dive_courses_nearby'
            defaultMessage='Dive courses nearby'
          />
        }
        coords={coords}
        link={window.searchCourses}
        type='courses'
      />
      <AdventureExploration
        sectionTitle={
          <FormattedMessage
            id='snorkeling_trips_nearby'
            defaultMessage='Snorkeling trips nearby'
          />
        }
        coords={coords}
        link={window.searchSnorkeling}
        type='snorkelling'
      />
    </Fragment>
  )
}
